<template>
  <div>
    <div class="air__utils__scrollTable mb-4">
      <a-table
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :scroll="{ x: '100%' }"
        :rowSelection="computedSelect"
        :loading="loading"
      >
        <template slot="name" slot-scope="name">
          <div>
            <div class="font-weight-bold">{{name}}</div>
            <!-- <div class="text-gray-4">{{user.position}}</div> -->
          </div>
        </template>
        <template slot="start_date" slot-scope="start_date">
          <span class="font-weight-bold">{{moment(start_date).format(dateFormat)}}</span>
        </template>
        <template slot="end_date" slot-scope="end_date">
          <span class="font-weight-bold">{{moment(end_date).format(dateFormat)}}</span>
        </template>
        <template slot="session" slot-scope="session">
          <a-tag v-if="session" color="green">{{session.name}}</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <div class="text-nowrap">
            <!-- Set current -->
            <!-- <a href="javascript:;" v-if="record.is_current !== 1" class="btn btn-sm btn-success btn-with-addon mr-2"
              @click="onSetCurrent(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-disc" />
              </span>
              Set Current
            </a> -->
            <!-- Edit -->
            <a href="javascript:;" v-if="rolesetting.editable" class="btn btn-sm btn-light btn-with-addon mr-2"
              @click="showEditModal(record)"
            >
              <span class="btn-addon">
                <i class="btn-addon-icon fe fe-edit" />
              </span>
              <!-- <edit-session ref="editBoard" @edited="handleEdited"/> -->
              Edit
            </a>
            <a-tooltip placement="top">
              <template slot="title" v-if="record.is_current === 1">
                <span>Cannot delete current session!</span>
              </template>
              <template slot="title" v-if="record.class_sections_count !== 0">
                <span>Cannot Delete. Related data present under this record!</span>
              </template>
              <span>
                <!-- Delete -->
                <a href="javascript:;" v-if="rolesetting.deletable" class="btn btn-sm btn-danger btn-with-addon"
                   @click="onDelete(record)"
                >
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-trash" />
                  </span>
                  Delete
                </a>
              </span>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>
    <EditTerm ref="editBoard" @edited="handleEdited"/>
  </div>
</template>
<script>
import moment from 'moment'
import EditTerm from '@/components/academicterm/Forms/Edit'

const columns = [
  {
    title: 'Academic Term',
    dataIndex: 'name',
    className: 'text-left text-gray-6',
    scopedSlots: { customRender: 'name' },
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: 'Start Date',
    dataIndex: 'start_date',
    key: 'start_date',
    scopedSlots: { customRender: 'start_date' },
    sorter: (a, b) => moment(a.start_date).unix() - moment(b.start_date).unix(),
  },
  {
    title: 'End Date',
    dataIndex: 'end_date',
    key: 'end_date',
    scopedSlots: { customRender: 'end_date' },
    sorter: (a, b) => moment(a.end_date).unix() - moment(b.end_date).unix(),
  },
  {
    title: 'Session',
    dataIndex: 'session',
    key: 'session',
    scopedSlots: { customRender: 'session' },
    sorter: (a, b) => {
      if (a.session && b.session) {
        return a.session.name.localeCompare(b.session.name)
      }
      return 0
    },
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    className: 'text-right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {

  name: 'TermsTable',
  components: {
    EditTerm,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    data: {
      type: Array,
      default: () => [],
    },
    rolesetting: { type: Object },
  },
  data: function() {
    return {
      columns,
      selectedRowKeys: [],
      dateFormat: 'DD-MM-YYYY',
    }
  },
  computed: {
    computedSelect: function() {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    moment,
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    showEditModal: function(record) {
      // this.$refs.editBoard.showModal(record.id)
      this.$eventBus.$emit('openSessionEditModal', record.id)
    },
    handleEdited: function () {
      this.$emit('updateTable')
    },
    // onSetCurrent: function(record) {
    //   this.$confirm({
    //     title: 'Are you sure?',
    //     content: 'Set ' + record.name + ' as current session?',
    //     okText: 'Yes',
    //     okType: 'primary',
    //     cancelText: 'No',
    //     onOk: () => {
    //       this.$nprogress.start()
    //       this.$http
    //         .get('/api/session/setcurrent/' + record.id)
    //         .then(({ data }) => {
    //           this.$emit('updateTable')
    //           this.$nprogress.done()
    //           this.$notification['info']({
    //             message: 'Current session changed Successfully!',
    //             description: 'current session is ' + data.data.name + ' now.',
    //           })
    //         })
    //         .catch(error => {
    //           this.$nprogress.done()
    //           this.$neoNotify.error(error)
    //         })
    //     },
    //     onCancel: () => {
    //       console.log('Cancel')
    //     },
    //   })
    // },
    onDelete: function(record) {
      this.$confirm({
        title: 'Are you sure delete this board?',
        content: 'Some descriptions',
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/lesson-plan/academic-terms/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Deleted Successfully!',
                description: record.name + ' has been deleted.',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
